import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { EditHistoryResponse } from '../Types/Responses/EditHistoryResponses'
import { GetHistoryRequest } from '../Types/Requests/EditHistoryService'

export default class EditHistoryService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/doctor-stations'
  }

  async getHistory(params: GetHistoryRequest): Promise<EditHistoryResponse> {
    try {
      const queryParams: Record<string, string | number> = {}

      if (params.startDate) {
        queryParams.startDate = new Date(params.startDate).toISOString()
      }
      if (params.endDate) {
        queryParams.endDate = new Date(params.endDate).toISOString()
      }
      if (params.page) {
        queryParams.page = params.page
      }
      if (params.limit) {
        queryParams.limit = params.limit
      }

      const { data } = await request.get<EditHistoryResponse>(
        `${this.getCompletePath()}/${params.doctorStationId}/audits`,
        queryParams
      )

      return data
    } catch (e) {
      console.error('Erro ao buscar histórico de edições', e)
      throw this.handleError(e, 'Não foi possível carregar o histórico de edições')
    }
  }
}
